import request from '@/utils/request'

const _Prefix = "/setting/rankManager"

// 查询职级信息列表
export function professionList(query) {
    return request({
        url: _Prefix + '/list',
        method: 'get',
        params: query
    })
}


// 查询职级信息详细
export function getProfession(id) {
    return request({
        url: _Prefix + '/' + id,
        method: 'get'
    })
}

// 新增职级信息
export function addProfession(data) {
    return request({
        url: _Prefix,
        method: 'post',
        data: data
    })
}

// 修改职级信息
export function updateProfession(data) {
    return request({
        url: _Prefix,
        method: 'put',
        data: data
    })
}

// 删除职级信息
export function delProfession(ids) {
    return request({
        url: _Prefix + '/' + ids,
        method: 'delete'
    })
}

// 删除业绩分配设置
export function delProfessionAllotSet(ids) {
    return request({
        url: '/setting/performanceAllotSet/' + ids,
        method: 'delete'
    })
}